import styled from "styled-components";

const SlideWrap = styled.div`
	width: 100%;
	height: 240px;
	margin-bottom: 20px;

	.swiper-wrapper .swiper-slide {
		width: 100%;
		height: 240px;
	}
`;

const SubTitle = styled.h4`
	margin-bottom: 20px;
	font-size: var(--medium-size);
	color: var(--emp-color);
`;
const InfoText = styled.p`
	line-height: 1.6;
	margin-bottom: 15px;
	color: var(--default-color);
`;

export {InfoText, SlideWrap, SubTitle};
